export default __webpack_public_path__ + "118f77c.png";